var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-card',{attrs:{"title":_vm.challenge.name}},[_c('challenge-review-step',{attrs:{"value":_vm.challenge,"read-only":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }